import { render, staticRenderFns } from "./findPwd.vue?vue&type=template&id=8031f28a&"
import script from "@viewJs/home/findPwd.js?vue&type=script&lang=js&"
export * from "@viewJs/home/findPwd.js?vue&type=script&lang=js&"
import style0 from "./findPwd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports